export { default as safePerformanceMark } from './utils/safePerformanceMark';
export { default as safePerformanceMarkStart } from './utils/safePerformanceMarkStart';
export { default as safePerformanceMarkEnd } from './utils/safePerformanceMarkEnd';
export * from './utils/clearPerfMarkers';
